import React from 'react';
import { Button } from 'react-bootstrap';
import { useClosure } from 'utils/hooks';
import useNumericForecastCP from 'utils/hooks/meteorology/useNumericForecastControlPanel';

export default function VariableButton({ text, value }: { text: string, value: string }) {
  const { setVariable, variable } = useNumericForecastCP();

  const activeStyle = variable === value ? 'btn-control-panel-active' : '';

  return (
    <Button variant="link" onClick={useClosure(setVariable, value)} className={`btn-control-panel ${activeStyle}`}>
      { text }
    </Button>
  );
}
